module.exports = __webpack_public_path__ + "static/media/bino_text.d7127bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/binokular/bino_text.png
// module id = 831
// module chunks = 0